import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import { QuestionTitle } from 'ui/Text'

import { TriggerUserActions } from '@/components/TriggerUserActions'
import { IndependentDatetimePicker } from '@/ui/molecules/IndependentDatetimePicker'

import { hasText } from '../../../utils/helpers'
import ZentakeFormContext from '../ZentakeFormContext'

function TimeQuestion({ question, isOfficeUse, response, sessions, mode }) {
  const formContext = React.useContext(ZentakeFormContext)
  const readonly = formContext.isQuestionReadonly(question)
  const willShowNotAllowedCursor =
    formContext.willShowNotAllowedCursor(question)

  const answer = formContext.getAnswer(question)
  const value =
    answer && answer.answer_time
      ? answer.answer_time
      : question.default_value || ''

  const isDirty = formContext.isQuestionDirty(question)
  const isValid = formContext.isQuestionValid(question)
  const questionError = formContext.getQuestionError(question)

  const [hasError, setHasError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(
    'This field is required'
  )

  const officeUsePreview = mode === 'preview' && question.is_office_use_only

  React.useEffect(() => {
    if (question?.date_default_value_now && !answer?.answer_raw) {
      formContext?.onAnswerChanged?.(question, moment().format('HH:mm:ss'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    setHasError(
      (isDirty && question?.is_required && !isValid) || hasText(questionError)
    )
    setErrorMessage(
      questionError && typeof questionError === 'string'
        ? questionError
        : 'This field is required'
    )
  }, [isDirty, question.is_required, isValid, questionError])

  function handleChange(value) {
    formContext?.onAnswerChanged?.(question, value)
  }

  return (
    <div>
      <QuestionTitle
        isOfficeUse={isOfficeUse || officeUsePreview}
        isRequired={question.is_required}
      >
        {question.text}
      </QuestionTitle>
      <TriggerUserActions>
        <IndependentDatetimePicker
          semibold
          data-packet-id={
            sessions?.fillResponseCustomer?.packetResponse?.packet?.id
          }
          data-response-id={response?.id}
          disabledGrayed={formContext?.mode === 'read-only'}
          errorLabel={errorMessage}
          hasError={hasError}
          id={`q-${question.id}`}
          isOfficeUse={isOfficeUse || officeUsePreview}
          isRequired={question.is_required}
          key={value}
          maxTime={question.date_max}
          minTime={question.date_min}
          onChange={(value) => handleChange(value ? value : undefined)}
          readonly={readonly}
          showFutureOnly={question?.date_future_only}
          showPastOnly={question?.date_past_only}
          type="time"
          value={value}
          willShowNotAllowedCursor={willShowNotAllowedCursor}
        />
      </TriggerUserActions>
    </div>
  )
}

TimeQuestion.propTypes = {
  question: PropTypes.object.isRequired,
}

export default React.memo(TimeQuestion)
